import type {
  MessageDirectionName,
  MessageStatusName,
  ReportMessageListItem,
} from "@multi-chat/shared";
import {
  incomingMessagePreview,
  messageTypeLabelKey,
} from "./incoming-report-presentation.js";
import {
  messagePreviewOrTemplate,
  originBadgeLabel,
  statusLabelKey,
} from "./outgoing-report-presentation.js";

export function directionLabelKey(direction: MessageDirectionName): string {
  switch (direction) {
    case "INBOUND":
      return "reports.messageLog.directions.INBOUND";
    case "OUTBOUND":
      return "reports.messageLog.directions.OUTBOUND";
    default: {
      const _exhaustive: never = direction;
      return _exhaustive;
    }
  }
}

export function messageLogOriginDisplay(
  t: (key: string, options?: Record<string, unknown>) => string,
  row: ReportMessageListItem,
): string {
  if (row.direction === "INBOUND") return "—";
  return originBadgeLabel(t, row.origin);
}

export function messageLogCampaignDisplay(row: ReportMessageListItem): string {
  if (row.direction === "INBOUND") return "—";
  const name = row.campaign?.campaignName?.trim() ?? "";
  return name.length > 0 ? name : "—";
}

export function messageLogPreview(
  t: (key: string, options?: Record<string, unknown>) => string,
  row: ReportMessageListItem,
): string {
  if (row.direction === "INBOUND") {
    return incomingMessagePreview(t, row);
  }
  return messagePreviewOrTemplate(row);
}

export function messageLogStatusLabel(
  t: (key: string, options?: Record<string, unknown>) => string,
  status: MessageStatusName,
): string {
  return t(statusLabelKey(status));
}

export { messageTypeLabelKey };

export { isActiveReportOrigin as isActiveProductOrigin } from "./active-report-origins.js";
